const plainText = (value) =>
  String(value || "")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/[*_~`]/g, "")
    .replace(/<[^>]+>/g, "")
    .replace(/^\s*[-*]\s+/gm, "")
    .replace(/\s+/g, " ")
    .trim();

/**
 * FAQ articles store each question as a ### heading and the answer as the
 * paragraphs that follow, until the next heading or a trailing ---.
 */
export const faqPairsFromMarkdown = (markdown) => {
  const lines = String(markdown || "").split(/\r?\n/);
  const pairs = [];
  let current = null;

  const flush = () => {
    if (!current) return;
    const text = plainText(current.lines.join("\n"));
    const name = plainText(current.name);
    if (name && text) pairs.push({ name, text });
    current = null;
  };

  for (const line of lines) {
    if (/^---\s*$/.test(line)) {
      flush();
      continue;
    }
    const question = line.match(/^###\s+(.+?)\s*$/);
    if (question) {
      flush();
      current = { name: question[1], lines: [] };
      continue;
    }
    if (/^#{1,2}\s+/.test(line)) {
      flush();
      continue;
    }
    if (current) current.lines.push(line);
  }
  flush();
  return pairs;
};

export const faqPageJsonLd = (pairs) => {
  const mainEntity = (pairs || [])
    .map((pair) => ({
      name: plainText(pair?.name),
      text: plainText(pair?.text),
    }))
    .filter((pair) => pair.name && pair.text)
    .map((pair) => ({
      "@type": "Question",
      name: pair.name,
      acceptedAnswer: {
        "@type": "Answer",
        text: pair.text,
      },
    }));

  if (!mainEntity.length) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  };
};
